import { axiosInventoryInstance } from '@/config/apiConfig';
import { API_URL_CONFIG } from '@/config/urlConfig/apiUrlConfig';
import { SingleOperatorResponse } from '@/store/sagas/operatorSaga';
import { AxiosResponse } from 'axios';

// Define the User interface representing the structure of the user object returned by the API
interface User {
  id: string;
  // ... other properties of the user object
}
interface DeleteSubApplication {
  id: string;
}

interface FetchSubApplication {
  page?: number;
  limit?: number;
  keywords?: string;
}

export const fetchsubApplications = ({
  page,
  limit,
}: FetchSubApplication): Promise<AxiosResponse<FetchSubApplication, any>> => {
  return axiosInventoryInstance.get(
    `${API_URL_CONFIG.SUBAPPLICATION.GET_ALL_SUBAPPLICATIONS}?page=${page}&limit=${limit}`,
  );
};

export const fetchsubApplication = (
  id: number,
): Promise<AxiosResponse<User>> => {
  return axiosInventoryInstance.get(
    `${API_URL_CONFIG.SUBAPPLICATION.GET_ALL_SUBAPPLICATIONS}/${id}`,
  );
};

export const createSubApplication = (
  payload: SingleOperatorResponse,
): Promise<AxiosResponse<User>> => {
  return axiosInventoryInstance.post(
    `${API_URL_CONFIG.SUBAPPLICATION.GET_ALL_SUBAPPLICATIONS}`,
    payload,
  );
};

export const updateSubApplication = (
  id: string,
  payload: SingleOperatorResponse,
): Promise<AxiosResponse<User>> => {
  return axiosInventoryInstance.patch(
    `${API_URL_CONFIG.SUBAPPLICATION.GET_ALL_SUBAPPLICATIONS}/${id}`,
    payload,
  );
};

export const deleteSubApplication = (
  id: string,
): Promise<AxiosResponse<DeleteSubApplication, any>> => {
  return axiosInventoryInstance.delete(
    `${API_URL_CONFIG.SUBAPPLICATION.GET_ALL_SUBAPPLICATIONS}/${id}`,
  );
};
